






import { Component, Vue, Prop } from 'vue-property-decorator';
import { FormQuestion } from '@/interfaces/registration/FormQuestion';
import QuestionInputTextBox from './QuestionInputTextBox.vue';
import QuestionInputTextArea from './QuestionInputTextArea.vue';
import QuestionInputDropDown from './QuestionInputDropDown.vue';
import QuestionInputRadioList from './QuestionInputRadioList.vue';
import QuestionInputCheckboxList from './QuestionInputCheckboxList.vue';
import QuestionInputRating from './QuestionInputRating.vue';
import QuestionInputSlider from './QuestionInputSlider.vue';
import QuestionInputFileUpload from './QuestionInputFileUpload.vue';
import QuestionInputNumber from './QuestionInputNumber.vue';
import { QuestionModel } from '@/interfaces/registration/models/QuestionModel';
import { QuestionsModel } from '@/interfaces/registration/models/QuestionsModel';

@Component({
  components: {
    QuestionInputTextBox,
    QuestionInputTextArea,
    QuestionInputDropDown,
    QuestionInputRadioList,
    QuestionInputCheckboxList,
    QuestionInputRating,
    QuestionInputSlider,
    QuestionInputFileUpload,
    QuestionInputNumber
  }
})
export default class QuestionInput extends Vue {
  @Prop({ default: () => { return {}; } }) readonly formQuestion!: FormQuestion;
  @Prop({ default: () => { return []; } }) readonly value!: QuestionsModel;

  get questionInputComponent (): string {
    let questionType;
    switch (this.formQuestion.questionType) {
      case 'Email':
        questionType = 'TextBox';
        break;
      default:
        questionType = this.formQuestion.questionType;
    }
    return 'QuestionInput' + questionType;
  }

  get model (): QuestionModel {
    return this.value[this.formQuestion.id as number];
  }

  set model (newValue: QuestionModel) {
    const newModel: QuestionsModel = {};
    newModel[newValue.id as number] = newValue;
    this.$emit('input', Object.assign({}, this.value, newModel));
  }
}
